import React, { useCallback } from "react";

import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import wave_1 from "@/assets/icons/wave-1.svg";
import wave_2 from "@/assets/icons/wave-2.svg";

interface StyleProps {
  fill: number;
}

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
const useStyles = makeStyles()((theme) => ({
  root: {
    height: 254,
    width: 254,
  },
  circle: {
    height: "100%",
    width: "100%",
    position: "relative",
    border: "6px solid #DFF5FF",
    borderRadius: "50%",
    overflow: "hidden",
    [theme.breakpoints.down("lg")]: {
      transform: "scale(.8)",
    },
    [theme.breakpoints.down("md")]: {
      transform: "scale(.5)",
    },
  },
  wave: {
    background: `url(${wave_1})`,
    backgroundSize: "400px 400px",
    backgroundRepeat: "repeat-x",
    position: "absolute",
    left: "-25%",
    bottom: "-300%",
    height: "400%",
    width: "150%",
    animation: "$flow 7s cubic-bezier( 0.36, 0.45, 0.63, 0.53) infinite",
    transform: "translate3d(0, 0, 0)",
    zIndex: 1,
  },
  wave2: {
    background: `url(${wave_2})`,
    backgroundSize: "400px 400px",
    backgroundRepeat: "repeat-x",
    position: "absolute",
    left: "-25%",
    bottom: "-300%",
    height: "400%",
    width: "150%",
    animation:
      "$counterFlow 7.6s cubic-bezier( 0.36, 0.45, 0.63, 0.53) infinite",
    transform: "translate3d(0, 0, 0)",
    zIndex: 1,
  },

  "@keyframes flow": {
    "0%": {
      backgroundPositionX: "-1200px",
    },
    "100%": {
      backgroundPositionX: "0px",
    },
  },

  "@keyframes counterFlow": {
    "0%": {
      backgroundPositionX: "1200px",
    },
    "100%": {
      backgroundPositionX: "0px",
    },
  },
}));

type Props = {
  waterIntakeTotal: number;
  waterIntakeTarget: number;
};

const WaveView: React.FC<Props> = ({ waterIntakeTarget, waterIntakeTotal }) => {
  const getFill = useCallback(() => {
    const percentage = Math.floor((waterIntakeTotal / waterIntakeTarget) * 100);
    const rounded = Math.floor(percentage / 10) * 10;

    const MAX_FILL = -100;
    const MIN_FILL = 210;

    if (rounded === 0) return MIN_FILL;
    if (rounded >= 100) return MAX_FILL;

    const result = MIN_FILL - rounded * 3.1;

    return result;
  }, [waterIntakeTarget, waterIntakeTotal]);

  const fill = getFill();

  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.circle}>
        <div
          className={classes.wave2}
          style={{ backgroundPositionY: `${fill}px` }}
        />
        <div
          className={classes.wave}
          style={{ backgroundPositionY: `${fill}px` }}
        />
      </div>
    </div>
  );
};

export default WaveView;
